import { render, staticRenderFns } from "./Assistance.vue?vue&type=template&id=5afe5766&"
import script from "./Assistance.vue?vue&type=script&lang=js&"
export * from "./Assistance.vue?vue&type=script&lang=js&"
import style0 from "./Assistance.vue?vue&type=style&index=0&id=5afe5766&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports